import React, {useEffect} from "react";
import {delay} from "@kopjra/uikit";
import $ from "jquery";

export interface Props {
    link: string;
}

export const WACZViewer: React.FC<Props> = ({link}) => {
    useEffect(() => {
        (async () => {
            try {
                for (let i = 0; i < 30; i++) {
                    await delay(1000);

                    // @ts-expect-error It works in the browser
                    const iframe = $($("replay-web-page")[0].shadowRoot).find("iframe");
                    const main = iframe.contents().find("replay-app-main")[0];
                    const element = $(main.shadowRoot).find("wr-coll");
                    if (element.length > 0) {
                        element.css("background-color", "#FFFFFF");
                        break;
                    }
                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, [link]);
    // @ts-expect-error It works in the browser
    return (<replay-web-page loading={"eager"} source={link} replayBase={"/js/"} useAdblock={true}></replay-web-page>);
};
